import React, { cloneElement } from "react";
import { StyleSheet, View } from "@react-pdf/renderer";

const Tr = ({ breakArray, index, length, children, breakStyle = {} }) => {
  const styles = StyleSheet.create({
    tr: {
      flexDirection: "row",
      justifyContent: "center",
    },
  });

  function shouldBreak() {
    return breakArray
      ? index !== 0 &&
        (index === breakArray[0] ||
          (index - breakArray[0]) % breakArray[1] === 0)
        ? true
        : false
      : false;
  }
  return (
    <View
      break={shouldBreak()}
      style={[styles.tr, shouldBreak() ? breakStyle : {}]}
    >
      {children}
    </View>
  );
};

export default Tr;
